import { CurbZonesAndRestrictionsQuery, RestrictionType } from "@/types/gql/graphql";

import { CurbZone } from "@/types/curb-zone.type";
import { TooltipType } from "@/types/map.type";

export type Restriction = CurbZonesAndRestrictionsQuery["restrictionsByBounding"][number];

export const trafficRestrictionType: Partial<Record<RestrictionType, string>> = {
  trafficRestriction: "Restriction de circulation Totale",
  alternateTrafficRestriction: "Restriction de circulation Alterné",
};

export const curbZoneRestrictionType: Partial<Record<RestrictionType, string>> = {
  moving: "Déménagement",
  publicDomainOccupation: "Occupation du domaine publique",
  constructionWork: "Travaux",
  oneTimeEvent: "Évenement ponctuel",
  recurringEvent: "Évenement récurrent",
  other: "Autres",
};

export type RestrictionModalProps = {
  saveRestriction: (promptedProperties: Restriction) => void;
  prefill: Restriction;
  cancel: (isEdit: boolean) => void;
  id?: string;
};

export type RestrictionPageParams = {
  disabledEndDate?: string;
  disabledStartDate?: string;
  view?: string;
  cityID?: string;
};

export type RestrictionHover = TooltipType<Restriction>;
export type CurbZoneHover = TooltipType<CurbZone>;
